import { Component, EventEmitter, OnInit, ViewChild, Output, Input } from '@angular/core';

// 3rd party imports
import { DxPopupComponent } from 'devextreme-angular';

// cc-imports
import { MessageBoxComponent, CCMessageBoxIcon, IconConstants } from 'cc-common';

@Component({
    selector: 'app-workflow-delete',
    templateUrl: './workflow-delete.component.html',
    styleUrls: ['./workflow-delete.component.scss']
})
export class WorkflowDeleteComponent implements OnInit {
    @ViewChild('deleteWorkflowPopup', { static: false }) deleteWorkflowPopup: DxPopupComponent;
    @ViewChild('deleteWorkflowMessageBox', { static: false }) deleteWorkflowMessageBox: MessageBoxComponent;

    @Input() workflowId: number;
    @Output() onClose = new EventEmitter<boolean>();
    @Output() onDeleteWorkflow = new EventEmitter<string>();

    visible = false;
    deleteWorkflowReason: string;

    iconClose: string = IconConstants.CLOSE;
    iconDelete: string = IconConstants.DELETE;

    ngOnInit() {
        this.show();
    }

    show(): void {
        this.visible = true;
    }

    onDeleteWorkflowPopUpShown(): void {
        this.visible = true;
        this.deleteWorkflowPopup.instance.repaint();
    }

    onDeleteWorkflowPopUpClose(): void {
        this.visible = false;
        this.onClose.emit(true);
    }

    onDeleteConfirmWorkflow(): void {
        if (this.deleteWorkflowReason && this.deleteWorkflowReason.toString().length > 2) {
            this.visible = false;
            this.onDeleteWorkflow.emit(this.deleteWorkflowReason);
            this.onClose.emit(true);
        } else {
            this.deleteWorkflowMessageBox.showWithFixedWidthAndIcon(
                CCMessageBoxIcon.info,
                'Information',
                'Please provide a reason to delete the AAP Workflow.',
                320
            );
        }
    }
}
